import { z } from "zod";

import type { GetGroupIdMembersParams } from "@/routes/_staff/ids/-api";

// Based on Swagger documentation parameters
export const SearchSchema = z.object({
  orderDirection: z.enum(["asc", "desc"]).optional().default("asc"),
  freeText: z.string().optional(),
  page: z.number().int().min(1).optional().default(1),
  pageSize: z.number().int().min(1).optional().default(100),
  orderBy: z.any().optional(),
}) satisfies z.ZodType<GetGroupIdMembersParams>;

export type SearchSchema = z.infer<typeof SearchSchema>;

/**
 * Schema for a single member in the group ID
 * Based on Swagger response schema
 */
export const groupIdMemberSchema = z.object({
  personId: z.string(),
  name: z.string(),
  avatarUrl: z.string(),
  email: z.string(),
});

/**
 * Schema for the members list response
 * Based on Swagger response schema
 */
export const groupIdMembersResponseSchema = z.object({
  items: z.array(groupIdMemberSchema),
  length: z.number(),
  count: z.number(),
  page: z.number(),
  maxPage: z.number(),
});

/**
 * Type definitions derived from the schemas
 */
export type GroupIdMember = z.infer<typeof groupIdMemberSchema>;
export type GroupIdMembersResponse = z.infer<
  typeof groupIdMembersResponseSchema
>;
